import { string } from 'yup';

const identityReg = RegExp('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');

export const uuidValidationSchema = string()
  .trim()
  .required('Id is required!')
  .matches(identityReg, 'Identity should be GUID format');
